import type {ReactElement} from 'react';
import React from 'react';
import {CircularProgressLoader} from '@Components/circular-progress-loader';
import type {PublishingLoaderScreenProps} from './publishing-loader-screen.types';

export function PublishingLoaderScreen({...props}: PublishingLoaderScreenProps): ReactElement {
  const {customHeight, loaderSize} = props;
  return (
    <div className={`${customHeight} flexbox flex-center`}>
      <CircularProgressLoader size={loaderSize} classes="_unmargin" />
    </div>
  );
}
